export const ORG_BILLING_TRANSFER_RETURN_PATH = "/org-billing-transfer/accept";

export const SAVE_PAYMENT_METHOD_ERROR = "Failed to save payment method";

export function buildOrgBillingTransferReturnUrl(requestId: string): string {
    const returnUrl = new URL(
        ORG_BILLING_TRANSFER_RETURN_PATH,
        window.location.origin,
    );
    returnUrl.searchParams.set("requestId", requestId);
    returnUrl.searchParams.set(
        "after",
        `${window.location.pathname}${window.location.search}`,
    );

    return returnUrl.toString();
}

export function toInAppPath(path: string | null | undefined): string {
    return path?.startsWith("/") && !path.startsWith("//") ? path : "/";
}
